import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";

export const itemColdefs = [
    {
        field: "woRecvNo",
        headerName: "WO Recv No",
        minWidth: window.innerWidth * 0.05,
        flex: 0.5,
        filter: true,
    },
    {
        field: "drawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
    },
    {
        field: "itemType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "itemDetails",
        headerName: "Item details",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "woQuantity",
        headerName: "WO quantity",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "avlStock",
        headerName: "Avl stock",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "rate",
        headerName: "Rate",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "amount",
        headerName: "Amount",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "displaySerialNo",
        headerName: "Display serial no",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
];

export const firstListColdefs = [
    {
        headerCheckboxSelection: true,
        checkboxSelection: true,
        width: 50,
        pinned: 'left',
        suppressSizeToFit: true
    },
    {
        field: "woRecvNo",
        headerName: "WO Recv No",
        minWidth: window.innerWidth * 0.06,
        flex: 0.8,
        filter: true,
    },
    {
        field: "woRecvDate",
        headerName: "WO Recv Date",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "customer",
        headerName: "Customer",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "totalQty",
        headerName: "Total Qty",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "totalwithTax",
        headerName: "Totalwith Tax",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "finalAmt",
        headerName: "Final Amt",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
];
export const secondListColdefs = [
    {
        field: "pendingQty",
        headerName: "Per ding Qty",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "idwoOrderRecv",
        headerName: "IDWO Order Recv",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "idwoOrderRecvItems",
        headerName: "IDWO Order Recv Items",
        minWidth: window.innerWidth * 0.15,
        flex: 1.5,
        filter: true,
    },
    {
        field: "idItem",
        headerName: "ID Item",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "drawingNo",
        headerName: "Drawing No",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "itemType",
        headerName: "Item Type",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "itemName",
        headerName: "Item Name",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "itemRemarks",
        headerName: "Item Remarks",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "amount",
        headerName: "Avl Stock",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    }
];

export const StockTransferPopup = (props) => {
    return (
        <ModalBasic
            id="stock-transfer"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            {!props.open && (
                <div className='input-fields p-[30px]'>
                    <span className="text-blue text-[16px] font-semibold">Stock transfer details</span>
                    <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                        <div className='input-grp'>
                            <label>Transfer no</label>
                            <TextInput type='text'
                                id='transferNo' name='transferNo'
                                value={props.stockObject.transferNo}
                                handleChange={(event) => props.handleChange(event, 'transferNo')}
                                className={props.validState?.error?.transferNo !== undefined ? "error" : ""}
                                disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Transfer date</label>
                            <TextInput type='date'
                                id='transferDate' name='transferDate'
                                value={props.stockObject.transferDate}
                                handleChange={(event) => props.handleChange(event, 'transferDate')}
                                className={props.validState?.error?.transferDate !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Order no</label>
                            <TextInput type='text'
                                id='orderNo' name='orderNo'
                                value={props.stockObject.orderNo}
                                handleChange={(event) => props.handleChange(event, 'orderNo')}
                                className={props.validState?.error?.orderNo !== undefined ? "error" : ""}
                            //disabled
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Order date</label>
                            <TextInput type='date'
                                id='ordDate' name='ordDate'
                                value={props.stockObject.ordDate}
                                handleChange={(event) => props.handleChange(event, 'ordDate')}
                                className={props.validState?.error?.ordDate !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Transfer to</label>
                            <MultiSelectDropdown
                                drpIdentity="Select transfer"
                                options={props.stockObject.transferList}
                                value={props.stockObject.idTransfer > 0 ? props.stockObject.transferList.find(x => x.value === props.stockObject.idTransfer) : 0}
                                onChange={(event) =>
                                    props.handleChangeForDropdown(event, "idTransfer")
                                }
                                className={props.validState?.error?.idTransfer !== undefined ? "error" : ""}
                            />

                        </div>
                        <div className='input-grp'>
                            <label>Vehicle no</label>
                            <TextInput type='text'
                                id='vehicleNo' name='vehicleNo'
                                value={props.stockObject.vehicleNo}
                                handleChange={(event) => props.handleChange(event, 'vehicleNo')}
                                className={props.validState?.error?.vehicleNo !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp'>
                            <label>Transporter</label>
                            <TextInput type='text'
                                id='Transporter' name='Transporter'
                                value={props.stockObject.Transporter}
                                handleChange={(event) => props.handleChange(event, 'Transporter')}
                                className={props.validState?.error?.Transporter !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className='input-grp col-span-2'>
                            <label>Address</label>
                            <textarea rows={3}
                                id='address' name='address'
                                value={props.stockObject.address}
                                onChange={(event) => props.handleChange(event, 'address')}
                                className={`h-full ${props.validState?.error?.address !== undefined ? "error" : ""}`}
                            />
                        </div>
                        <div className='btn-grp flex gap-2.5 col-start-1'>
                            <button className="save-btn btns" onClick={() => props.addWorkOrder()}>Add work order</button>
                        </div>
                    </div>
                    <div className="process-table h-[35vh] mt-2.5">
                        <span className="text-blue text-[16px] font-semibold">Transfer item details</span>
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.itemRowData}
                                columnDefs={itemColdefs}
                                onCellClicked={props.handleCellClickItemList}
                                //onGridReady={props.onGridReady}
                                //overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                //overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                            />
                        </div>
                    </div>
                    <div className='btn-total flex items-end justify-between mt-[35px]'>
                        <div className='btn-grp flex gap-2.5'>
                            <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                            <button className="edit-btn btns">Print</button>
                            <button className="save-btn btns">Preview</button>
                            <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                        </div>
                        <div className='total-grp flex items-center gap-2.5'>
                            <div className='input-grp'>
                                <label>Total articles</label>
                                <TextInput type='text'
                                    id='totalArticals' name='totalArticals'
                                    value={props.stockObject.totalArticals}
                                    handleChange={(event) => props.handleChange(event, 'totalArticals')}
                                    className={props.validState?.error?.totalArticals !== undefined ? "error" : ""}
                                    disabled
                                />
                            </div>
                            <div className='input-grp'>
                                <label>Total Quantity</label>
                                <TextInput type='text'
                                    id='totalQuantity' name='totalQuantity'
                                    value={props.stockObject.totalQuantity}
                                    handleChange={(event) => props.handleChange(event, 'totalQuantity')}
                                    className={props.validState?.error?.totalQuantity !== undefined ? "error" : ""}
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {props.open && (
                <div className='tables p-[30px]'>
                    <span className="text-blue text-[16px] font-semibold">Purchase order selection</span>
                    <div className="process-table h-[35vh] mt-[5px] mb-2 pb-[8px] border-b border-slate-200">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.firstList}
                                columnDefs={firstListColdefs}
                                onCellClicked={props.handleCellClickfirstList}
                                rowSelection="multiple"
                                overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                onSelectionChanged={(event) => {
                                    const selectedRowsselectedRows = event.api.getSelectedRows();
                                    props.onSelectionChanged(selectedRowsselectedRows);
                                }}
                            />
                        </div>
                    </div>

                    <span className="text-blue text-[16px] font-semibold">Select Vendor</span>
                    <div className="process-table h-[35vh] mt-[5px]">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.secondList}
                                columnDefs={secondListColdefs}
                                //onCellClicked={props.handleCellClickSecondPIList}
                                overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                            />
                        </div>
                    </div>

                    {/* <span className="text-blue text-[16px] font-semibold">Vendor Price Details</span>
                    <div className="process-table h-[35vh] mt-[5px]">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.thirdPIList}
                                //columnDefs={vendorPriceColdefs}
                                //onCellClicked={props.handleCellClickThirdPIList}
                                overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                            /> 
                        </div>
                    </div> */}

                    <div className='btn-grp flex gap-2.5 mt-5'>
                        <button className="update-btn btns" onClick={() => props.addProduct()}>Add products</button>
                        <button className="delete-btn btns" onClick={() => props.back()}>Back</button>
                    </div>
                </div>
            )}
        </ModalBasic>
    )
}